import Swiper from 'swiper';

(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the testimonials-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		const swiperContainer = $block.find('.swiper')[0];
		const swiperNext = $block.find('.swiper-button-prev');
		const swiperPrev = $block.find('.swiper-button-next');
		const swiper = new Swiper(swiperContainer, {
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 16,
			cssMode: true,
		});
		swiperNext.on('click', function () {
			swiper.slidePrev();
		});
		swiperPrev.on('click', function () {
			swiper.slideNext();
		});
	};

	const swiper = new Swiper('.swiper-container', {
		on: {
			slideChange: function () {
				const nextArrow = document.getElementById('nextArrow');
				const prevArrow = document.getElementById('prevArrow');

				// Check if at the first slide
				if (this.isBeginning) {
					prevArrow.classList.add('disabled');
				} else {
					prevArrow.classList.remove('disabled');
				}

				// Check if at the last slide
				if (this.isEnd) {
					nextArrow.classList.add('disabled');
				} else {
					nextArrow.classList.remove('disabled');
				}
			},
		},
	});

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-testimonials-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=testimonials-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
